
import { Component, Vue } from 'vue-property-decorator'
import GoodsResultCard from '@/views/industryMall/shop/template/GoodsResultCard.vue'
import { ShopGoodsListDto } from '@/api/shoppingMall'
import { getCyStoreActivityGoodsList } from '@/api/industryMall'
import { Getter } from 'vuex-class'
import { LoginReturnDataDto } from '@/utils/h5ToApp'
// import { GoodsValid } from '@/views/industryMall/shop/shop'

@Component({
  name: 'HotSale',
  components: { GoodsResultCard }
})
export default class DiscountSale extends Vue {
  @Getter info!: LoginReturnDataDto
  @Getter companyId!: string
  @Getter providerId!: string
  params = {
    partnerCompanyId: 'system',
    keyword: '',
    pageSize: 20,
    pageIndex: 1
  }
  goodsList: ShopGoodsListDto[] = []
  refreshing = false
  loading = false
  finished = false

  created() {
    this.params.partnerCompanyId = this.info.partnerCompanyId || 'system'
    this.getList()
  }

  getList() {
    getCyStoreActivityGoodsList({ ...this.params })
      .then((res) => {
        console.log('res', res.data)
        if (this.refreshing) {
          this.goodsList = []
        }
        this.goodsList = this.goodsList.concat(res.data.records) || []
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false
        this.refreshing = false
      })
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
  }

  onSearch() {
    this.onRefresh()
  }

  /**
   * 上拉加载更多
   * */
  onLoad() {
    this.loading = true
    this.params.pageIndex++
    this.getList()
  }

  reloadList() {
    this.params.pageIndex = 1
    this.getList()
  }

  goBack() {
    this.$router.back()
  }

  /**
   * 直接跳转回首页
   */
  goHome() {
    this.$goHomeBack()
  }

  /**
   * 跳转商品详情
   */
  toDetail(item) {
    this.$router.push({
      path: '/goodsMallDetail',
      query: {
        goodsId: item.goodsId,
        storeId: item.storeId
      }
    })
  }
}
